import React from 'react';
import './index.scss';
import Footer from '../Footer';
import Activity from '../Activity';
import fitComedyKidsIImg from '../../assets/img/comedy_optimized/454.JPG';
import fitComedyKidsIIImg from '../../assets/img/comedy_optimized/517.JPG';
import fitComedyKidsIIIImg from '../../assets/img/comedy_optimized/664.JPG';
import fitComedyAdultsIImg from '../../assets/img/comedy_optimized/213.JPG';
import fitComedyAdultsIIImg from '../../assets/img/comedy_optimized/588.JPG';
import fitComedyTeensImg from '../../assets/img/CMVB-228.JPG';

const Comedy = () => {
   const class1 = {
      image: fitComedyKidsIImg,
      title: 'Comedia Musical Kids I',
      desc: 'En comedia musical kids queremos lograr un espacio donde la creatividad, el juego, la música, la danza y la actuación se conviertan en los principales actores. Trabajamos su confianza para poder brillar arriba y abajo del escenario. Aprovechá los escuentos por familia: 2º integrante 20% menos. 3º integrante 40% menos.',
      prof: [
         {
            name: 'Rocío Pecantet',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Candela Innocenti',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Malena Junco',
            img: fitComedyKidsIImg,
         },
      ],
      charac: {
         ages: 'de 3 a 6 años',
         dateTime: 'Lunes y Miércoles 17:30h',
         duration: '1H',
         wpp: '5493492289969',
      },
      enroll: 'https://forms.gle/hikDfEMUbK64pRkL7',
      location: 'Bv Santa Fe 1158, Rafaela, Santa Fe',
   };

   const class2 = {
      image: fitComedyKidsIIImg,
      title: 'Comedia Musical Kids II',
      desc: 'En comedia musical kids queremos lograr un espacio donde la creatividad, el juego, la música, la danza y la actuación se conviertan en los principales actores. Trabajamos su confianza para poder brillar arriba y abajo del escenario. Aprovechá los escuentos por familia: 2º integrante 20% menos. 3º integrante 40% menos.',
      prof: [
         {
            name: 'Rocío Pecantet',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Candela Innocenti',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Malena Junco',
            img: fitComedyKidsIImg,
         },
      ],
      charac: {
         ages: 'de 7 a 9 años',
         dateTime: 'Lunes y Miércoles 18:30h',
         duration: '1H',
         wpp: '5493492289969',
      },
      enroll: 'https://forms.gle/hikDfEMUbK64pRkL7',
      location: 'Bv Santa Fe 1158, Rafaela, Santa Fe',
   };

   const class3 = {
      image: fitComedyKidsIIIImg,
      title: 'Comedia Musical Pre Teens',
      desc: 'Son dos estímulos semanales que les permitirán desarrollar y adquirir el manejo de las disciplinas que conforman la comedia musical. Aprovechá los escuentos por familia: 2º integrante 20% menos. 3º integrante 40% menos.',
      prof: [
         {
            name: 'Celina Astudillo',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Malena Junco',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Valentina Oregioni',
            img: fitComedyKidsIImg,
         },
      ],
      charac: {
         ages: 'de 10 a 12 años',
         dateTime: 'Lunes, Miércoles y Viernes 18:30h',
         duration: '1H',
         wpp: '5493492289969',
      },
      enroll: 'https://forms.gle/KMZjkN1xB2TQCUrFA',
      location: 'Av. Italia 153, Rafaela, Santa Fe',
   };

   const class4 = {
      image: fitComedyTeensImg,
      title: 'Comedia Musical Teens',
      desc: 'Son dos estímulos semanales que les permitirán desarrollar y adquirir el manejo de las disciplinas que conforman la comedia musical. Aprovechá los escuentos por familia: 2º integrante 20% menos. 3º integrante 40% menos.',
      prof: [
         {
            name: 'Celina Astudillo',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Malena Junco',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Valentina Oregioni',
            img: fitComedyKidsIImg,
         },
      ],
      charac: {
         ages: 'de 13 a 15 años',
         dateTime: 'Lunes, Miércoles y Viernes 19:30h',
         duration: '1H',
         wpp: '5493492289969',
      },
      enroll: 'https://forms.gle/KMZjkN1xB2TQCUrFA',
      location: 'Av. Italia 153, Rafaela, Santa Fe',
   };

   const class5 = {
      image: fitComedyAdultsIImg,
      title: 'Comedia Musical Adultos I',
      desc: 'Son dos estímulos semanales que les permitirán desarrollar y adquirir el manejo de las disciplinas que conforman la comedia musical. Aprovechá los escuentos por familia: 2º integrante 20% menos. 3º integrante 40% menos.',
      prof: [
         {
            name: 'Celina Astudillo',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Malena Junco',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Valentina Oregioni',
            img: fitComedyKidsIImg,
         },
      ],
      charac: {
         ages: 'De 16 años en adelante.',
         dateTime: 'Lunes, Miércoles y Jueves 13:00hs',
         duration: '1H',
         wpp: '5493492289969',
      },
      enroll: 'https://forms.gle/QzjZg3deNb5dxPgP6',
      location: 'Av. Italia 153, Rafaela, Santa Fe',
   };

   const class6 = {
      image: fitComedyAdultsIIImg,
      title: 'Comedia Musical Adultos II',
      desc: 'Son dos estímulos semanales que les permitirán desarrollar y adquirir el manejo de las disciplinas que conforman la comedia musical. Aprovechá los escuentos por familia: 2º integrante 20% menos. 3º integrante 40% menos.',
      prof: [
         {
            name: 'Celina Astudillo',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Malena Junco',
            img: fitComedyKidsIImg,
         },
         {
            name: 'Valentina Oregioni',
            img: fitComedyKidsIImg,
         },
      ],
      charac: {
         ages: 'De 16 años en adelante.',
         dateTime: 'Lunes, Martes y Miércoles 20:30h',
         duration: '1H',
         wpp: '5493492289969',
      },
      enroll: 'https://forms.gle/QzjZg3deNb5dxPgP6',
      location: 'Av. Italia 153, Rafaela, Santa Fe',
   };

   const classes = [class1, class2, class3, class4, class5, class6];

   return (
      <>
         <div className='dance-container'>
            <div className='header-bg'></div>
            <div className='dance-title'>
               <article>
                  <h1>CLASES DE COMEDIA MUSICAL</h1>
               </article>
            </div>
            <div className='dance-content'>
               <div className='cards-container'>
                  {classes.map((element, i) => <Activity
                     classImg={element.image}
                     classTitle={element.title}
                     classDescription={element.desc}
                     professors={element.prof}
                     ages={element.charac.ages}
                     dateTime={element.charac.dateTime}
                     duration={element.charac.duration}
                     wpp={element.charac.wpp}
                     enroll={element.enroll}
                     location={element.location}
                     key={`${element.wpp}_${i}`}
                  />)}
               </div>
            </div>
         </div>

         <footer>
            <Footer />
         </footer>
      </>
   );
};

export default Comedy;
